var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var EdelweissAssetClass;
(function (EdelweissAssetClass) {
    EdelweissAssetClass["EQUITY"] = "Equity Related";
    EdelweissAssetClass["FI"] = "Fixed Income";
    EdelweissAssetClass["MP"] = "Managed Portfolio";
    EdelweissAssetClass["CO"] = "Commodity";
    EdelweissAssetClass["RE"] = "Real Estate";
})(EdelweissAssetClass || (EdelweissAssetClass = {}));
export var MangedPortfolioComposition;
(function (MangedPortfolioComposition) {
    MangedPortfolioComposition["MF"] = "MF";
    MangedPortfolioComposition["AIF"] = "AIF";
    MangedPortfolioComposition["PMS"] = "PMS";
    MangedPortfolioComposition["ETF"] = "ETF";
    MangedPortfolioComposition["StructuredProducts"] = "SP";
    MangedPortfolioComposition["INVITS"] = "INVITS";
})(MangedPortfolioComposition || (MangedPortfolioComposition = {}));
export var MutualFundComposition;
(function (MutualFundComposition) {
    MutualFundComposition["EQUITY"] = "Equity";
    MutualFundComposition["HYBRID"] = "Hybrid";
    MutualFundComposition["DEBT"] = "Debt";
    MutualFundComposition["OTHER"] = "Other";
})(MutualFundComposition || (MutualFundComposition = {}));
export var FixedIncomeComposition;
(function (FixedIncomeComposition) {
    FixedIncomeComposition["Bonds"] = "BO";
    FixedIncomeComposition["NCD"] = "NCD";
    FixedIncomeComposition["CertOfDeposit"] = "COD";
    FixedIncomeComposition["CommPaper"] = "CP";
    FixedIncomeComposition["Warrant"] = "W";
    FixedIncomeComposition["Debentures"] = "DB";
    FixedIncomeComposition["IndianDepoReceipt"] = "IDR";
    FixedIncomeComposition["PreferenceShare"] = "PS";
    FixedIncomeComposition["CorpFD"] = "CFD";
    FixedIncomeComposition["RBIBonds"] = "RBO";
    FixedIncomeComposition["EC54"] = "54EC";
})(FixedIncomeComposition || (FixedIncomeComposition = {}));
export var productCodeValues = __spreadArray(__spreadArray([], __read(Object.values(FixedIncomeComposition)), false), __read(Object.values(MangedPortfolioComposition)), false);
